import { i18n } from '@/plugins/i18n';
import { AuthenticationErrorCode } from '@/store/types';

const IDPKey = 'idp';
const loginWithPasswordKey = 'loginWithPassword';

export const getAuthenticationErrorMessage = (
  code: AuthenticationErrorCode,
  interpolationData?: Record<string, unknown>
): string => {
  const keyMap: { readonly [K in AuthenticationErrorCode]: string } = {
    [AuthenticationErrorCode.LOCKED]: 'app.authenticationErrorLocked',
    [AuthenticationErrorCode.TEMPORARILY_LOCKED]:
      'app.authenticationErrorTemporarilyLocked',
    [AuthenticationErrorCode.NOT_CONFIRMED]:
      'app.authenticationErrorNotConfirmed',
    [AuthenticationErrorCode.NOT_APPROVED]:
      'app.authenticationErrorNotApproved',
    [AuthenticationErrorCode.WRONG_CREDENTIALS]: 'app.authenticationError',
    [AuthenticationErrorCode.CHALLENGE_EXPIRED]:
      'app.authenticationErrorChallengeExpired',
    [AuthenticationErrorCode.WRONG_OTP]: '2fa.wrongOtp',
    [AuthenticationErrorCode.ERROR]: 'common.genericError',
    [AuthenticationErrorCode.WRONG_RECOVERY_CODE]: '2fa.wrongRecoveryCode',
    [AuthenticationErrorCode.IDP_NOT_FOUND]: 'errors.unknownTenant',
    [AuthenticationErrorCode.UNKNOWN_USER]: 'errors.unknownUser',
    [AuthenticationErrorCode.SUBJECT_MISMATCH]: 'errors.subjectMismatch',
    [AuthenticationErrorCode.UNEXPECTED_ERROR]: 'errors.unexpectedError'
  };
  return i18n
    .t(keyMap[code] ?? 'common.genericError', interpolationData ?? {})
    .toString();
};

export const setIdPInLocalStorage = (idp: string): void => {
  localStorage.setItem(IDPKey, idp);
};

export const getIdPFromLocalStorage = (): string | null => {
  const idp = localStorage.getItem(IDPKey);
  if (idp) {
    return idp;
  }
  return null;
};
export const setLoginWithPasswordInLocalStorage = (
  loginWithPassword: boolean
): void => {
  localStorage.setItem(loginWithPasswordKey, JSON.stringify(loginWithPassword));
};

export const getLoginWithPasswordFromLocalStorage = (): boolean => {
  const value = localStorage.getItem(loginWithPasswordKey);
  if (value) {
    return JSON.parse(value);
  }
  return false;
};
